import { render, staticRenderFns } from "./MassageFeedback.vue?vue&type=template&id=018f6082&scoped=true"
import script from "./MassageFeedback.vue?vue&type=script&lang=js"
export * from "./MassageFeedback.vue?vue&type=script&lang=js"
import style0 from "./MassageFeedback.vue?vue&type=style&index=0&id=018f6082&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f6082",
  null
  
)

export default component.exports